'use client';

import { createContext, useContext } from 'react';
import { Locale } from '@/lib/i18n/config';

type TranslationContextType = {
  locale: Locale;
  translations: Record<string, Record<string, any>>;
};

const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export function TranslationProvider({
  locale,
  translations,
  children,
}: {
  locale: Locale;
  translations: Record<string, Record<string, any>>;
  children: React.ReactNode;
}) {
  return (
    <TranslationContext.Provider value={{ locale, translations }}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslationContext() {
  const context = useContext(TranslationContext);
  if (!context) {
    return null;
  }
  return context;
}
